import { CircularProgress } from '@mui/material'
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { checkoutFormFields } from './checkoutFormFields'

export default function LinxRedirector() {
  const [searchParams] = useSearchParams()
  const basketId = searchParams.get('BasketID')
  const checkoutUrl = searchParams.get('CheckoutURL')
  const lang = searchParams.get('lang')

  const {
    t,
    i18n: { changeLanguage },
  } = useTranslation()

  // Los dos parámetros vienen de startLinx. Si falta alguno --o llega el string
  // "undefined"-- el form POSTearía a una URL relativa inexistente y el comprador
  // veía un 405 en /linx/undefined. Preferimos mostrarle el error.
  const isMissingParam = (value) => !value || value === 'undefined' || value === 'null'
  const hasCheckoutData = !isMissingParam(basketId) && !isMissingParam(checkoutUrl)

  const redirectToLinx = async () => {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = checkoutUrl
    // Los campos salen de checkoutFormFields para que un test cuide la invariante:
    // si el form lleva SessionID, la tienda no adopta el carrito que armó core y el
    // comprador llega al checkout con el carrito vacío.
    checkoutFormFields(basketId).forEach(({ name, value }) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      form.append(input)
    })
    window.document.body.append(form)
    form.submit()
  }

  useEffect(() => {
    if (lang !== undefined) {
      changeLanguage(lang)
    }
  }, [lang])

  useEffect(() => {
    if (!hasCheckoutData) {
      console.error('LinxRedirector sin datos de checkout', { basketId, checkoutUrl })
      return
    }
    redirectToLinx()
  }, [])

  if (!hasCheckoutData) {
    return (
      <Container>
        <Label>{t('checkout.textError')}</Label>
        <Label>{t('checkout.textErrorTwo')}</Label>
      </Container>
    )
  }

  return (
    <Container>
      <Label>{t('checkout.linxRedirecting')}</Label>
      <CircularProgress color="inherit" />
    </Container>
  )
}

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Label = styled.span`
  margin: 10px;
`
